import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var Containers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, args, context, info) {
    var userId, maxNumberOfResults, principalId, siteId, sessionId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = args.userId, maxNumberOfResults = args.maxNumberOfResults, principalId = args.principalId, siteId = args.siteId, sessionId = args.sessionId;
          _context.next = 3;
          return context.fetch("".concat(context.url.collaborationGraph, "/v1/collaborationgraph/user/container"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
              },
              containerTypes: ['confluenceSpace', 'jiraProject'],
              maxNumberOfResults: maxNumberOfResults,
              userId: userId,
              expanded: true
            })
          }).then(function (res) {
            // Matches type of QueryData['Containers'] in
            // packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
            return res.json();
          });
        case 3:
          return _context.abrupt("return", _context.sent);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function Containers(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default Containers;